import React, { useState } from 'react';
import { motion } from 'framer-motion';
export function PricingTable() {
  const [selected, setSelected] = useState<'pro' | 'acelerador'>('acelerador');
  return <section id="pricing" className="py-16 px-4 pt-[25px] pb-[25px]" data-id="element-203">
      <div className="max-w-lg mx-auto" data-id="element-204">
        <div className="text-center mb-8" data-id="element-205">
          <h2 className="text-3xl md:text-4xl font-black mb-1" data-id="element-206">
            ELEGÍ TU{' '}
            <span className="text-brand" data-id="element-207">
              ULTRAPACK TERAPIA OCUPACIONAL LISTA™
            </span>
          </h2>
          <p className="text-gray-400 mt-2" data-id="element-208">
            Las dos opciones incluyen los 6 bonos estratégicos completos
          </p>
        </div>

        <div className="flex flex-col gap-5" data-id="element-209">
          {/* Plan 1 — ULTRAPACK ESTÁNDAR */}
          <motion.button type="button" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} onClick={() => setSelected('pro')} className={`relative text-left bg-dark-card rounded-2xl p-5 flex items-start gap-4 transition-all cursor-pointer ${selected === 'pro' ? 'border-2 border-brand shadow-[0_0_30px_rgba(59,130,246,0.15)]' : 'border border-dark-border'}`} data-id="element-210">
            {/* Radio */}
            <div className="mt-1 flex-shrink-0" data-id="element-211">
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors ${selected === 'pro' ? 'border-brand' : 'border-gray-600'}`} data-id="element-212">
                {selected === 'pro' && <div className="w-2.5 h-2.5 rounded-full bg-brand" data-id="element-213" />}
              </div>
            </div>

            {/* Content */}
            <div className="flex-1 min-w-0" data-id="element-214">
              <div className="flex items-start justify-between gap-3" data-id="element-215">
                <div data-id="element-216">
                  <div className="mb-1 text-[18px]" data-id="element-217">📘</div>
                  <h3 className="font-bold text-[14px]" data-id="element-218">
                    ULTRAPACK TERAPIA OCUPACIONAL LISTA™
                  </h3>
                  <p className="text-gray-400 mt-1 text-[12px]" data-id="element-219">
                    6 Tomos + 6 Bonos
                  </p>
                </div>
                <div className="text-right flex-shrink-0" data-id="element-220">
                  <div className="text-gray-500 line-through text-xs" data-id="element-221">
                    $34.990
                  </div>
                  <div className="text-2xl md:text-3xl font-black text-white leading-tight" data-id="element-222">
                    $19.990
                  </div>
                </div>
              </div>
            </div>
          </motion.button>

          {/* Plan 2 — ULTRAPACK + MÉTODO RENTABLE-MENTE */}
          <motion.button type="button" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} onClick={() => setSelected('acelerador')} className={`relative text-left bg-dark-card rounded-2xl p-5 pt-7 flex items-start gap-4 transition-all cursor-pointer ${selected === 'acelerador' ? 'border-2 border-brand shadow-[0_0_30px_rgba(59,130,246,0.15)]' : 'border border-dark-border'}`} data-id="element-223">
            {/* Badge MÁS ELEGIDO */}
            {selected === 'acelerador' && <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-brand text-white text-[10px] font-bold px-3 py-0.5 rounded-full whitespace-nowrap shadow-md" data-id="element-224">
                ⭐ MÁS ELEGIDO
              </span>}
            {/* Radio */}
            <div className="mt-1 flex-shrink-0" data-id="element-225">
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors ${selected === 'acelerador' ? 'border-brand' : 'border-gray-600'}`} data-id="element-226">
                {selected === 'acelerador' && <div className="w-2.5 h-2.5 rounded-full bg-brand" data-id="element-227" />}
              </div>
            </div>

            {/* Content */}
            <div className="flex-1 min-w-0" data-id="element-228">
              <div className="flex items-start justify-between gap-3" data-id="element-229">
                <div data-id="element-230">
                  <div className="text-xl mb-1" data-id="element-231">🏆</div>
                  <h3 className="font-bold text-[14px]" data-id="element-232">
                    ULTRAPACK TERAPIA OCUPACIONAL LISTA™ + MÉTODO CONSULTORIO
                    ÉLITE™
                  </h3>
                  <p className="text-gray-400 mt-1 text-[12px]" data-id="element-233">
                    6 Tomos + 6 Bonos + Método Consultorio Élite™ (gestión,
                    marketing, precios y negocio)
                  </p>
                </div>
                <div className="text-right flex-shrink-0" data-id="element-234">
                  <div className="text-gray-500 line-through text-xs" data-id="element-235">
                    $43.990
                  </div>
                  <div className="text-2xl md:text-3xl font-black text-brand leading-tight" data-id="element-236">
                    $27.990
                  </div>
                </div>
              </div>
              <p className="text-brand font-bold mt-3 text-[10px]" data-id="element-237">
                AHORRÁS $16.000. La más elegida por TOs que quieren
                profesionalizarse y cobrar lo que merecen.
              </p>
            </div>
          </motion.button>
        </div>

        {/* CTA Button */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="mt-6" data-id="element-238">
          <a href={selected === 'acelerador' ? 'https://ultrapack.digital/cart/47747708780718:1' : 'https://ultrapack.digital/cart/47747705667758:1'} target="_blank" rel="noopener noreferrer" className="w-full block text-center bg-brand hover:bg-brand-dark text-white font-bold py-4 px-6 rounded-xl transition-all hover:scale-[1.02] shadow-[0_0_30px_rgba(59,130,246,0.4)] text-[16px]" data-id="element-239">
            {selected === 'acelerador' ? '→ QUIERO EL ULTRAPACK + MÉTODO CONSULTORIO ÉLITE™' : '→ QUIERO MI ULTRAPACK AHORA'}
          </a>
        </motion.div>

        <div className="mt-8 flex flex-wrap justify-center gap-6 text-sm text-gray-500" data-id="element-240">
          <div className="flex items-center space-x-2" data-id="element-241">
            <span data-id="element-242">🔒</span> <span data-id="element-243">Pago seguro</span>
          </div>
          <div className="flex items-center space-x-2" data-id="element-244">
            <span data-id="element-245">⚡</span> <span data-id="element-246">Acceso en 5 min</span>
          </div>
          <div className="flex items-center space-x-2" data-id="element-247">
            <span data-id="element-248">🛡️</span> <span data-id="element-249">Garantía 7 días</span>
          </div>
          <div className="flex items-center space-x-2" data-id="element-250">
            <span data-id="element-251">💳</span> <span data-id="element-252">Mercado Pago</span>
          </div>
        </div>
      </div>
    </section>;
}